import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/tuition_assistance_config_resource.rb
// Registered from the systemic missing-schema audit (the #9130/#8988 class:
// an API-emittable JSON:API type the FE manifest never registered). Distinct
// from the 'tas-assistance' type.
const TuitionAssistanceConfigSchema = withDefaults({
  type: 'tuition-assistance-config',
  fields: [
    { kind: 'attribute', name: 'tuitionPlanName' },
    { kind: 'attribute', name: 'description' },
    { kind: 'attribute', name: 'isActive' },
    { kind: 'attribute', name: 'custom' },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: { async: false, inverse: null },
    },
  ],
});

export default TuitionAssistanceConfigSchema;
